import * as yup from 'yup'
import { DepositForm } from '../components/Deposit/Deposit'

const depositSchema = () => {
  return yup.object<Partial<Record<keyof DepositForm, yup.AnySchema>>>({})
}

export default depositSchema
